import React from "react";
import { RCCProgress, RCCTooltip } from "react-common-components";
import { useTranslation } from "src/context/Translations/context";
import { ICard } from "./interface";
import Container, { Body, ContainerWithMargin, DivContent, DivContentPercetage, Header } from "./styles";

const Card: React.FC<ICard> = ({
	color,
	options,
	title,
	children,
	percentage,
	percentageColor,
	percentagePredicted,
	onClickPercentage,
	hidePercentage = false,
	customHeader,
	maxCards,
	widthProgress,
	layout
}) => {

	const { translate } = useTranslation();

	return (
		<Container maxCards={maxCards}>
			<ContainerWithMargin color={color}>
				<Header>
					{customHeader || 
					<>
						<span className="title" title={title}>{title}</span>
						<div>{options}</div>
					</>
					}
				</Header>
				<Body>
					{!hidePercentage && (
						<DivContentPercetage>
							<RCCProgress 
								width={widthProgress ?? "70px"} 
								value={percentage || 0} 
								layout="circle"
								color={percentageColor}
								onClick={onClickPercentage}
								styleInline={onClickPercentage ? "cursor: pointer; padding: 5px" : undefined}
							/>

							{
								layout === "withProgressBarPredicted" && 
								<RCCTooltip
									color="purple"
									text={`% ${translate("Previsto")}`}
									position="bottom"
								>
									<RCCProgress
										value={percentagePredicted || 0} 
										layout="line"
									/>
								</RCCTooltip>
							}						
						</DivContentPercetage>
					)}
					<DivContent>
						{children}
					</DivContent>
				</Body>
			</ContainerWithMargin>
		</Container>
	);
};

export default Card;
